import { Injectable, Inject, NgZone } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { LoadScriptsService } from './load-scripts.service'

@Injectable({ providedIn: 'root' })
export class StyleLoader {

  constructor(@Inject(DOCUMENT) private document: Document, private zone: NgZone, private load: LoadScriptsService) {
    console.info(`## ${this.constructor.name}`)
  }

  loadStyle(nick: string, url?: string) {
    this.load.loadStyle(url || `assets/${nick}/styles.css`).subscribe(() => null)
  }

  /**
   * Switch styles for program change - removes old style and loads new
   * @param oldNick The previous program nick
   * @param newNick The new program nick
   * @param newUrl Optional URL for the new program's CSS
   */
  switchStyle(oldNick: string, newNick: string, newUrl?: string) {
    // Remove old style from cache and DOM
    const oldUrl = `assets/${oldNick}/styles.css`
    this.load.removeStyle(oldUrl)

    // Load new style
    this.loadStyle(newNick, newUrl)
  }

  loadFont(name: string, fonts: any) {
    if (fonts) {
      if (fonts.urlFamilyMonospace) this.load.loadStyle(fonts.urlFamilyMonospace).subscribe(() => null)
      if (fonts.urlFamilySansSerif) this.load.loadStyle(fonts.urlFamilySansSerif).subscribe(() => null)
      // for (const f of fonts.split(',')) {
      //   if (f.indexOf('sans-serif') === -1 ) {
      //     this.load.loadStyle(`https://fonts.googleapis.com/css2?family=${f}&display=swap`).subscribe(() => null)
      //   }
      // }
    }
  }

}
